var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container mx-auto mb-10"},[_c('h2',{staticClass:"text-xl mb-1"},[_vm._t("title")],2),_vm._v(" "),_c('p',{staticClass:"text-gray-500 mb-2"},[_vm._t("description")],2),_vm._v(" "),_c('div',{staticClass:"bg-white rounded shadow p-8"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a86f19c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/sections/extra-layout.vue
// module id = null
// module chunks = 